import React from 'react';
import PropTypes from 'prop-types';

import {connect} from 'react-redux';

import {fetchRootTaxonChildren, fetchTaxonChildrenBySlug} from '../../ducks/taxons';

import memoizeOne from 'memoize-one';
import {taxonNestedSet} from '../../utils/taxons';

import Loader from '../../components/loader/Loader';
import Menu from '../../components/menu/Menu';
import Button from '../../components/button/Button';
import {Link} from 'react-router';


@connect(({ui, taxons}, {menuTaxon}) => ({
  ui,
  menu: taxons.children[menuTaxon || ui.menuTaxon],
  breadcrumbs: ui.breadcrumbs,
  mainTaxons: taxons.root.children
}))
export default class MenuContainer extends React.PureComponent {
  static fetchData = ({dispatch, mainTaxons, menuTaxon, ui, menu}) => Promise.all([
    mainTaxons === undefined && dispatch(fetchRootTaxonChildren()),
    menu === undefined && dispatch(fetchTaxonChildrenBySlug(menuTaxon || (ui && ui.menuTaxon) || process.env.PRIMARY_TAXON))
  ]);

  getMenuTree = memoizeOne(menu => (menu && !!menu.length) && taxonNestedSet.nest(menu));

  componentDidMount() {
    MenuContainer.fetchData(this.props);
  }

  componentDidUpdate() {
    MenuContainer.fetchData(this.props);
  }

  render() {
    const {mainTaxons, menu, breadcrumbs, mobile} = this.props;

    if (!mainTaxons || !menu) {
      return <Loader section/>;
    }

    const inactiveMainTaxon = (mainTaxons && breadcrumbs && !!breadcrumbs.length) && mainTaxons.find(it => it.code !== breadcrumbs[0].code);

    return (
      <React.Fragment>
        <Menu
          mobile={mobile}
          items={this.getMenuTree(menu)}
          breadcrumbs={breadcrumbs}
        />

        {!!inactiveMainTaxon && (
          <Button
            component={Link}
            to={`/${inactiveMainTaxon.slug}`}
            full gradient
          >
            Switch to {inactiveMainTaxon.name}
          </Button>
        )}
      </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./containers/menuContainer/MenuContainer.js